import { Box, Link, Typography } from '@mui/material';
import React, { useState } from 'react';
import { failureMessages, validatePassword } from '/b2b/common/helpers/Password';
import { mapDispatchToProps, mapStateToProps } from './ResetPassword.container';

import { FormikTextField } from '/b2b/common/components/FormControls/TextField';
import FormikValidationForm from '/b2b/common/components/organisms/FormikValidationForm';
import InvalidIcon from '@mui/icons-material/Close';
import Locale from '/b2b/common/components/Locale';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import UnauthenticatedPaths from '../UnauthenticatedRoutes.paths';
import ValidIcon from '@mui/icons-material/Check';
import { connect } from 'react-redux';
import { resetPasswordSchema } from './ResetPassword.schema';

// eslint-disable-next-line no-use-before-define
export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);

export function ResetPassword(props) {
    const { code, onResetPassword, resetAuthState, username } = props;
    const [passwordChecks, updatePasswordChecks] = useState(validatePassword('', true));
    const onPasswordChange = event => {
        updatePasswordChecks(validatePassword(event.target.value, true));
    };

    return (
        <Box
            display="flex"
            flexDirection="column"
            height="100%"
            alignItems="stretch"
            justifyContent="center"
            sx={{ mx: 'auto', px: 2, maxWidth: 700, width: '100%' }}
        >
            <FormikValidationForm
                initialValues={{ code, username }}
                validationSchema={resetPasswordSchema}
                onSubmit={onResetPassword}
                title="password.reset"
                submitText="common.reset"
                validateOnMount
            >
                <Box
                    display="flex"
                    flexDirection="column"
                    width="100%"
                    flexGrow={1}
                    gap={0.5}
                    alignItems="center"
                    mt={4}
                    mb={1}
                    sx={theme => (theme.breakpoints.down('lg') ? { justifyContent: 'center' } : {})}
                >
                    <FormikTextField
                        name="username"
                        label="common.email"
                        autoComplete="email"
                        fullWidth
                        required
                        mb={1}
                    />
                    <FormikTextField
                        name="code"
                        label="common.fields.code.label"
                        autoComplete="off"
                        fullWidth
                        required
                        mb={1}
                    />
                    <FormikTextField
                        autoComplete="off"
                        fullWidth
                        label="common.fields.newPassword.label"
                        name="newPassword"
                        type="password"
                        onChange={onPasswordChange}
                        required
                    />
                    <Box p={1} alignContent="flex-start" width="100%">
                        {props.failureMessages.map(([key, message]) => (
                            <Typography gutterBottom key={key} variant="body2">
                                {passwordChecks[key] ? (
                                    <ValidIcon color="success" sx={{ verticalAlign: 'middle' }} />
                                ) : (
                                    <InvalidIcon color="error" sx={{ verticalAlign: 'middle' }} />
                                )}
                                <Box
                                    ml={1}
                                    component="span"
                                    sx={{ lineHeight: 1.5, verticalAlign: 'middle' }}
                                >
                                    <Locale path={message} />
                                </Box>
                            </Typography>
                        ))}
                    </Box>
                    <FormikTextField
                        autoComplete="off"
                        fullWidth
                        label="password.confirmNew"
                        name="confirmNewPassword"
                        type="password"
                        required
                    />
                </Box>
            </FormikValidationForm>
            <Box mt={5}>
                <Typography variant="body1">
                    <Locale path="password.didNotGetCode" />{' '}
                    <Link
                        fontWeight="bold"
                        component={RouterLink}
                        onClick={resetAuthState}
                        to={UnauthenticatedPaths.FORGOT_PASSWORD}
                    >
                        <Locale path="password.resend" />
                    </Link>
                </Typography>
                <Typography variant="body1">
                    <Locale path="password.remember" />{' '}
                    <Link
                        component={RouterLink}
                        fontWeight="bold"
                        onClick={resetAuthState}
                        to={UnauthenticatedPaths.SIGN_IN}
                    >
                        <Locale path="common.signIn" />
                    </Link>
                </Typography>
            </Box>
        </Box>
    );
}

ResetPassword.propTypes = {
    code: PropTypes.string,
    failureMessages: PropTypes.array.isRequired,
    isLoading: PropTypes.bool,
    onResetPassword: PropTypes.func.isRequired,
    resetAuthState: PropTypes.func.isRequired,
    username: PropTypes.string,
};

ResetPassword.defaultProps = { code: '', failureMessages };
